import React, { useState, useEffect } from "react";
import { FiUser, FiMapPin, FiHash } from "react-icons/fi";
import InputField from "../../../ResuableCompoment/InputField";
import SelectField from "../../../ResuableCompoment/SelectField";
import Statemaster from "../../../../DummyJson/Statemaster.json";

const ShopDetails = ({ data, onUpdate }) => {
  const [formData, setFormData] = useState({
    shopName: data.shopName || "",
    state: data.state || "",
    district: data.district || "",
    landmark: data.landmark || "",
    pincode: data.pincode || "",
    shopAddress: data.shopAddress || "",
    gstNumber: data.gstNumber || "",
    gstTradeName: data.gstTradeName || "",
  });

  useEffect(() => {
    setFormData({
      shopName: data.shopName || "",
      state: data.state || "",
      district: data.district || "",
      landmark: data.landmark || "",
      pincode: data.pincode || "",
      shopAddress: data.shopAddress || "",
      gstNumber: data.gstNumber || "",
      gstTradeName: data.gstTradeName || "",
    });
  }, [data]);

  const handleChange = (e) => {
    const updatedFormData = {
      ...formData,
      [e.target.name]: e.target.value,
    };
    setFormData(updatedFormData);
    onUpdate(updatedFormData);
  };

  return (
    <div className="w-full">

      {/* SECTION HEADING (STATIC) */}
      <h3 className="text-lg font-semibold text-[#0A2A4F] mb-6">
        Shop Information
      </h3>

      {/* INPUT GRID */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 min-h-[380px]">

        <SelectField
          label={
            <span>
              State *
            </span>
          }
          name="state"
          value={formData.state}
          onChange={handleChange}
          options={Statemaster.states.map((state) => ({
            value: state.state,
            label: state.state,
          }))}
        />

        <SelectField
          label={
            <span>
              District *
            </span>
          }
          name="district"
          value={formData.district}
          onChange={handleChange}
          options={
            Statemaster.states
              .find((state) => state.state === formData.state)
              ?.districts.map((district) => ({
                value: district,
                label: district,
              })) || []
          }
        />

                <InputField
          type="text"
          label={
            <span>
              GST Number *
            </span>
          }
          icon={FiHash}
          value={formData.gstNumber}
          onChange={handleChange}
          name="gstNumber"
          placeholder="Enter GST Address"
        />


        <InputField
          type="text"
          label={<span>GST Trade Name *</span>}
          icon={FiUser} 
          value={formData.gstTradeName}
          onChange={handleChange}
          name="gstTradeName"
          placeholder="Enter GST Trade Name"
        />

        <InputField
          type="text"
          label={
            <span>
              Shop Name *
            </span>
          }
          icon={FiUser}
          value={formData.shopName}
          onChange={handleChange}
          name="shopName"
          placeholder="Enter Shop Name"
        />

        <InputField
          type="text"
          label={
            <span>
              Landmark *
            </span>
          }
          icon={FiMapPin}
          value={formData.landmark}
          onChange={handleChange}
          name="landmark"
          placeholder="Enter Landmark"
        />

        <InputField
          type="text"
          label={
            <span>
              Pincode *
            </span>
          }
          icon={FiHash}
          value={formData.pincode}
          onChange={handleChange}
          name="pincode"
          placeholder="Enter Pincode"
        />

        <InputField
          type="text"
          label={
            <span>
              Shop Address *
            </span>
          }
          icon={FiMapPin}
          value={formData.shopAddress}
          onChange={handleChange}
          name="shopAddress"
          placeholder="Enter Shop Address"
        />
      </div>
    </div>
  );
};

export default ShopDetails;
